var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from '../../spacing/Inset';
import Small from '../../typography/Small';
import { AccountDetailsWrapper, DrawerHeaderBase, Image, LogoWrapper, Title, TitleWrapper } from './subcomponents';
import handleImageError from '../../../helpers/handleImageError';
const DrawerHeader = (_a) => {
    var { img, title, subtitle, alt, className, fallbackImage } = _a, props = __rest(_a, ["img", "title", "subtitle", "alt", "className", "fallbackImage"]);
    return (_jsxs(DrawerHeaderBase, Object.assign({ className: className }, props, { children: [img && (_jsx(LogoWrapper, { children: _jsx(Image, { src: img, alt: alt, onError: (e) => handleImageError(e, fallbackImage) }) })), _jsx(AccountDetailsWrapper, { children: _jsxs(Inset, Object.assign({ horizontal: "xsmall", left: "small", right: "xsmall" }, { children: [_jsx(TitleWrapper, { children: _jsx(Title, Object.assign({ as: "h2", weight: "bold" }, { children: title })) }), typeof subtitle === 'string' ? (_jsx(Small, Object.assign({ weight: "light" }, { children: subtitle }))) : (subtitle)] })) })] })));
};
export default DrawerHeader;
